import { render, staticRenderFns } from "./exportPackageData.vue?vue&type=template&id=2aa4ec58&"
import script from "./exportPackageData.vue?vue&type=script&lang=js&"
export * from "./exportPackageData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports